// extracted by mini-css-extract-plugin
export default {"root":"BillAlreadyPaidInputs_root__vcAHm","isPaidDiv":"BillAlreadyPaidInputs_isPaidDiv__K1beh","label":"BillAlreadyPaidInputs_label__7FBCA"};